/* WRITE SKETCH & — foundation runtime
 * Handles .ws-reveal scroll-in animation. Re-runs on Shopify section reload.
 */
(function () {
  if (window.__wsFoundationInit) return;
  window.__wsFoundationInit = true;

  function reveal(entries, observer) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }

  function makeObserver() {
    if (typeof IntersectionObserver === 'undefined') return null;
    return new IntersectionObserver(reveal, {
      threshold: 0.12,
      rootMargin: '0px 0px -40px 0px'
    });
  }

  var io = makeObserver();

  function init(root) {
    var scope = root || document;
    var nodes = scope.querySelectorAll('.ws-reveal:not(.is-visible)');
    if (!io) {
      nodes.forEach(function (n) { n.classList.add('is-visible'); });
      return;
    }
    nodes.forEach(function (n) { io.observe(n); });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:select', function (e) { init(e.target); });
})();

/* ============================================================
   Ink-drop cursor — lerp follow on hover devices
   ============================================================ */
(function () {
  if (window.__wsCursorInit) return;
  window.__wsCursorInit = true;
  if (typeof window.matchMedia !== 'function') return;
  if (window.matchMedia('(hover: none)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function start() {
    var c = document.getElementById('wsInkCursor');
    if (!c) return;
    var tx = -100, ty = -100, x = -100, y = -100;
    document.addEventListener('mousemove', function (e) {
      tx = e.clientX - 14;
      ty = e.clientY - 14;
    });
    function tick() {
      x += (tx - x) * 0.75;
      y += (ty - y) * 0.75;
      c.style.transform = 'translate(' + x + 'px,' + y + 'px)';
      requestAnimationFrame(tick);
    }
    tick();
  }

  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();
